import styled from '@emotion/styled'
import { ButtonActions } from 'components/ButtonActions'
import { WizardContent } from 'components/wizard/wizardContent/WizardContent'
import { BREAKPOINTS, pxToRem } from 'utils/styled'

export const SButtonActions = styled(ButtonActions)`
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0), rgba(255, 255, 255, 1));

  padding: 5vw;

  @media ${BREAKPOINTS.MD.min} {
    position: sticky;
    padding: 0;
    bottom: var(--p-spacing);
    margin: var(--p-spacing);
    margin-left: auto;
  }

  @media ${BREAKPOINTS.MD.max} {
    position: fixed;
    bottom: 0;
  }
`

export const SWizardContent = styled(WizardContent)`
  max-width: 47.75rem;
  width: 100%;
  margin: 4rem auto 3.75rem;
  padding-left: var(--p-spacing);
  padding-right: var(--p-spacing);

  @media ${BREAKPOINTS.LG.max} {
    max-width: unset;
    padding-top: 0;
    margin-left: 0;
    margin-right: 0;
  }

  @media ${BREAKPOINTS.MD.max} {
    margin-bottom: 2.5rem;
  }
`

export const SContainer = styled.form`
  align-items: stretch;
  max-height: 100vh;
  top: 0;
  flex-grow: 1;
  display: flex;
  flex-direction: column;

  @media ${BREAKPOINTS.MD.max} {
    margin-bottom: ${pxToRem(100)}rem;
    max-height: unset;
  }
`
